import { ScriptLoader } from "@fastoche/ui-core/util/script-loader";
import { APP_CONFIG } from "@/app/config";

export async function loadGoogleMaps() {
    return ScriptLoader.default
        .loadScript(`https://maps.googleapis.com/maps/api/js?key=${APP_CONFIG.GOOGLE_MAPS_API_KEY}&libraries=places`);
}
